import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class ManagerUserType {
  public readonly key = 'ManagerUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Manager;
}
